import React from "react";

const Vibe = () => {
  return (
    <section
      id="vibe"
      data-testid="vibe-section"
      className="relative px-6 md:px-12 lg:px-24 py-24 md:py-36"
    >
      <div className="grid md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-3">
          <div className="font-mono-plex text-[11px] tracking-[0.3em] uppercase text-[#FF2A2A] flex items-center gap-3">
            <span className="h-px w-8 bg-[#FF2A2A]" /> 01 — The Vibe
          </div>
        </div>

        <div className="md:col-span-9">
          <h2
            data-testid="vibe-quote"
            className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#F5F2E6]"
          >
            If you like bars that feel{" "}
            <span className="text-stroke">polished</span>,{" "}
            <span className="text-stroke">upscale</span> or{" "}
            <span className="text-stroke">cocktail-focused</span> — this
            probably <span className="text-[#FF2A2A]">won't</span> be your
            scene.
          </h2>

          <p className="mt-10 max-w-3xl text-lg md:text-xl text-[#A3A3A3] leading-relaxed">
            If you like authentic downtown dive bars where strangers actually
            talk to each other and nobody cares about appearances — welcome to
            one of <span className="text-[#FFB800]">Houston's staples</span>.
          </p>

          <div className="mt-12 inline-block tilt-r border border-[#FFB800]/40 bg-[#1A1A1A] px-5 py-3 font-mono-plex text-xs tracking-[0.2em] uppercase text-[#FFB800] neon-amber">
            "Galveston beach bar dropped into downtown Houston."
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vibe;
